import React, { useState } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import "./query-form.css";

function QueryForm() {

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [treatment, setTreatment] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      name: name,
      mobile: mobile,
      treatment: treatment
    };

    try {
      await fetch("https://script.google.com/macros/s/AKfycbys3A3y6F1gqmRJQaRTs6SHzax1jant_OxYPZdsDckwf8dVN08bjOKH37PjDRq6hH4iSg/exec", {
        method: "POST",
        body: JSON.stringify(data)
      });

      alert("Submitted Successfully!");

      setName("");
      setMobile("");
      setTreatment("");

    } catch (error) {
      alert("Error submitting form");
    }
  };

  return (
    <Form className="query-container align-items-center" onSubmit={handleSubmit}>

      <Row className="g-5 align-items-center">

        <Col md>
          <Form.Control
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Col>

        <Col md>
          <Form.Control
            type="tel"
            placeholder="Mobile No"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
        </Col>

        <Col md>
          <Form.Select
            value={treatment}
            onChange={(e) => setTreatment(e.target.value)}
            required
          >
            <option value="">Select Treatment</option>

            <optgroup label="Skin Treatments">
              <option value="Acne Treatment">Acne Treatment</option>
              <option value="Pigmentation Treatment">Pigmentation Treatment</option>
              <option value="Anti Aging Treatment">Anti Aging Treatment</option>
              <option value="Skin Glow / Facial Treatment">Skin Glow / Facial Treatment</option>
              <option value="Laser Skin Treatment">Laser Skin Treatment</option>
            </optgroup>

            <optgroup label="Hair Treatments">
              <option value="Hair Fall Treatment">Hair Fall Treatment</option>
              <option value="Hair Regrowth Treatment">Hair Regrowth Treatment</option>
              <option value="PRP Hair Therapy">PRP Hair Therapy</option>
              <option value="Dandruff Treatment">Dandruff Treatment</option>
            </optgroup>

            <optgroup label="Health Treatments">
              <option value="Weight Loss Treatment">Weight Loss Treatment</option>
              <option value="Diet & Nutrition Consultation">Diet & Nutrition Consultation</option>
              <option value="General Health Consultation">General Health Consultation</option>
            </optgroup>

          </Form.Select>
        </Col>

        <Col xs="auto">
          <Button variant="warning" type="submit" className="fw-bold shadow-sm">
            SUBMIT
          </Button>
        </Col>

      </Row>

    </Form>
  );
}

export default QueryForm;